import { api } from "./api";

export const applicationService = {
  // Get all applications
  getApplications: () => api.get("/lns/application/").then((res) => res.data),

  // Get application by ID
  getApplication: (id) =>
    api.get(`/lns//application/${id}`).then((res) => res.data),

  // Create application
  createApplication: (appData) => api.post("/lns//application", appData),

  // Update application
  updateApplication: (id, appData) =>
    api.put(`/lns//application/${id}`, appData),

  // Delete application
  deleteApplication: (id) => api.delete(`/lns//application/${id}`),
};
